module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/framework/footer/footer.component.scss
// module id = ./src/app/components/framework/footer/footer.component.scss
// module chunks = main